<template>
  <div>
    <a-modal
      title="编辑文章"
      v-model="visible"
      @ok="handleSubmit"
      :maskClosable="false"
      width="1200px"
    >
      <a-form
        :form="form"
      >
        <a-form-item
          label="标题"
          :label-col="{ span: 1 }"
          :wrapper-col="{ span: 22 }"
        >
          <a-input
            v-decorator="[
              'title',
              {rules: [{ required: true, message: 'Please input your note!' }]}
            ]"
          />
        </a-form-item>
        <a-form-item
          label="分类"
          :label-col="{ span: 1 }"
          :wrapper-col="{ span: 22 }"
        >
          <a-select
            v-decorator="[
              'categroy',
              {rules: [{ required: true, message: 'Please select your gender!' }]}
            ]"
            placeholder="选择分类"
            @change="handleSelectChange"
          >
            <a-select-option :value="item.id" v-for="item in cateList" >
              -- {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="摘要"
          :label-col="{ span: 1 }"
          :wrapper-col="{ span: 22 }"
        >
          <a-input
            v-decorator="[
              'note',
              {rules: [{ required: true, message: 'Please input your note!' }]}
            ]"
          />
        </a-form-item>
        <a-form-item
        >
          <!-- bidirectional data binding（双向数据绑定） -->
          <quill-editor
            v-model="content"
            class="quill-editor"
            ref="myQuillEditor"
            :options="editorOption"
            @change="onEditorChange($event)"
          >

          </quill-editor>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import '../../../../node_modules/quill/dist/quill.core.css'
import '../../../../node_modules/quill/dist/quill.snow.css'
import '../../../../node_modules/quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
import { uploadArticle } from '@/api/manage'
export default {
  components: {
    quillEditor
  },
  data () {
    return {
      visible: false,
      formLayout: 'horizontal',
      form: this.$form.createForm(this),
      // 富文本数据
      content: '',
      editorOption: {
        // some quill options
      },
      id: '',
      cateId: '',
      cateList: []
    }
  },
  methods: {
    show (record, list) {
      this.visible = true
      // console.log(record)
      this.$nextTick(() => {
        this.content = record.content
        this.id = record.id
        this.cateId = record.category_id // 获取categoryid
        this.cateList = list
        this.form.setFieldsValue({ 'title': record.title, 'categroy': record.label, 'note': record.excerpt })
      })
    },
    showModal () {
      this.visible = true
    },
    // 文本域操作
    onEditorChange ({ quill, html, text }) {
      this.content = html
    },
    // 新增文章form提交
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        // console.log(values)
        // console.log(this.cateId)
        // console.log(this.id)
        if (!err) {
          this.upload({ id: this.id, title: values.title, excerpt: values.note, content: this.content, category_id: this.cateId })
        }
      })
    },
    upload (parmas) {
      return uploadArticle(parmas)
        .then(res => {
          this.visible = false
          this.$message.success(res.msg)
          this.form.resetFields()
          this.$emit('ok')
          this.content = ''
        })
        .catch((err) => this.requestFailed(err))
        .finally(() => {
          this.loading = false
        })
    },
    handleSelectChange (value) {
      this.cateId = value
    },
    requestFailed (err) {
      // console.log(err)
      // this.$notification['error']({
      //   message: '错误',
      //   description: ((err.response || {}).data || {}).msg || '请求出现错误，请稍后再试',
      //   duration: 4
      // })
    }
  }
}
</script>

<style scoped>
  .quill-editor {
    width: 92%;
    height: 300px;
    margin: 0 auto 70px;
  }
</style>
